import { Breadcrumb } from 'antd';
import React from "react";

export default (() => {
  return (
    <Breadcrumb style={{textAlign: 'left'}}>
      <Breadcrumb.Item>推送配置</Breadcrumb.Item>
    </Breadcrumb>
  )
})